import axios from '@/api';
import authHeader from './auth-header';
import store from "@/store";

class AuthService {
    login(user) {
        return axios
            .post(process.env.VUE_APP_API_URL + 'auth/signin', {
                loginId: user.loginId,
                password: user.password
            })
            .then(response => {
                if (response.data.accessToken && response.data.accessToken != null) {
                    localStorage.setItem('user', JSON.stringify(response.data));
                }                
                return response.data;
            });
    }

    logout() {
        localStorage.removeItem('user');
    }

    register(user) {
        return axios.post(process.env.VUE_APP_API_URL + 'auth/signup', {
            loginId: user.loginId,
            email: user.email,
            password: user.password
        });
    }

    modifyPassword(user) {
        return axios.post(process.env.VUE_APP_API_URL + 'auth/modifyPass', {
                loginId: JSON.parse(localStorage.getItem('user')).loginId,
                password: user.password
            },
            {
                headers: {
                    ...authHeader()
                },
                withCredentials: true
            }
        ).then(response => {
            return response.data;
        });
    }

    refreshToken() {
        return axios.post('auth/refresh', {}, {
            headers: {
                ...authHeader()
            },
            withCredentials: true
        }).then(res => {
            const user = JSON.parse(localStorage.getItem('user'));

            const newUser = {
                ...user,
                ...res.data
            };

            localStorage.setItem(
                'user',
                JSON.stringify(newUser)
            );

            store.commit("auth/setUser", newUser);
            store.commit("auth/updateTokenInfo");

            return res;
        });
    }
}

export default new AuthService();